import React, { Component } from "react";
import { connect } from "react-redux";
import projActions from "../../../_actions/projActions";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import _ from "lodash";
import Select from "react-select";
import AlertModal from "../../_common/AlertModal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import unitActions from "../../../_actions/unitActions";
import distOptions from "../../../_constants/distOptions";
import MultiselectTable from "../../_common/MultiselectTable";

class EditProjectUnitsModal extends Component {
  state = {
    distFilter: null,
    selectedUnits: [],
    deletedUnits: [],
    unitStaffList: [],
    selectedRowIndex: null,
    showAlert_cancel: false,
    sortColumn: { path: "distUnit", order: "asc" },
    error: null,
  };

  columns = [
    { path: "distUnit", label: "Dist-Unit", isSortable: true },
    {
      path: "unitManagerFullName",
      label: "Unit Mgr",
      isSortable: true,
      content: (unit) => <small>{unit.unitManagerFullName}</small>,
    },
  ];

  componentDidMount() {
    const { projectUnits, user, tabId, dispatch } = this.props;
    const selectedUnits = [...projectUnits];
    dispatch(unitActions.getAll(user.district, tabId)).then(() =>
      this.setState({
        selectedUnits,
        distFilter: distOptions.with59.find((o) => o.value === user.district),
      })
    );
  }

  handleChange_distFilter = (distFilter) => {
    const { dispatch, tabId } = this.props;
    dispatch(unitActions.getAll(distFilter.value, tabId)).then(() =>
      this.setState({ distFilter })
    );
  };

  handleSubmit_editProjectUnits = (e) => {
    e.preventDefault();
    const { dispatch, project, toggleEditProjectUnitsModal } = this.props;
    let selectedUnits = [...this.state.selectedUnits];
    dispatch(projActions.saveProjectUnits(selectedUnits, project.projectId)).then(() =>
      toggleEditProjectUnitsModal()
    );
  };

  handleClick_cancel = (e) => {
    e.preventDefault();
    this.toggleAlert_cancel();
  };
  toggleAlert_cancel = () =>
    this.setState({ showAlert_cancel: !this.state.showAlert_cancel });
  handleAlert_cancel = (actionType) => (e) => {
    e.preventDefault();
    this.toggleAlert_cancel();
    if (actionType === "accept") this.props.toggleEditProjectUnitsModal();
  };

  handleSort = (sortColumn) => this.setState({ sortColumn });

  addProjectUnit = (unit) => {
    const { unitList } = this.props;
    // Determine if the unit being added is being 'recovered'
    let deletedUnits = [...this.state.deletedUnits];
    let selectedUnits = [...this.state.selectedUnits];
    const recoverableUnit = deletedUnits.find((u) => u.unitId === unit.unitId);
    if (recoverableUnit !== undefined) {
      // Add the recoverable unit back to selectedUnits
      selectedUnits.push(recoverableUnit);
      // Then remove it from the recoverable list
      deletedUnits = deletedUnits.filter((u) => u.unitId !== recoverableUnit.unitId);
    } else {
      const unitToAdd = unitList.find((u) => u.unitId === unit.unitId);
      if (unitToAdd) selectedUnits.push(unitToAdd);
    }
    this.setState({
      selectedUnits,
      deletedUnits,
    });
  };

  removeProjectUnit = (unitId) => {
    const { selectedUnits } = this.state;
    const deletedUnits = [...this.state.deletedUnits];
    const unitToDelete = selectedUnits.find((u) => u.unitId === unitId);
    if (unitToDelete !== undefined) deletedUnits.push(unitToDelete);
    this.setState({
      selectedUnits: selectedUnits.filter((u) => u.unitId !== unitId),
      deletedUnits,
    });
  };

  getData = () => {
    const { unitList } = this.props;
    const { sortColumn } = this.state;
    return _.orderBy(unitList, [sortColumn.path], [sortColumn.order]);
  };

  renderProjectUnits = () => {
    const { selectedUnits } = this.state;
    return (
      <div className="card flex-grow-1 assigned-unit-list">
        <div className="card-body bg-lightgray">
          <h5 className="text-muted">Selected Project Units</h5>
          {selectedUnits &&
            selectedUnits.map((u, index) => (
              <div key={`projUnitRow_${index}`} className="card my-2 mx-0">
                <div className="card-body">{u.distUnit}</div>
              </div>
            ))}
        </div>
      </div>
    );
  };

  render() {
    const { selectedUnits, deletedUnits, distFilter, sortColumn, showAlert_cancel } =
      this.state;
    const { showEditProjectUnitsModal, toggleEditProjectUnitsModal } = this.props;
    const data = this.getData();
    const closeBtn = (
      <button className="close" onClick={toggleEditProjectUnitsModal}>
        <FontAwesomeIcon icon="times" className="fa-fw text-white" />
      </button>
    );
    return (
      <React.Fragment>
        <Modal
          isOpen={showEditProjectUnitsModal}
          toggle={this.handleClick_cancel}
          className={this.props.className}
          fade={false}
          size={"xl"}
        >
          <ModalHeader
            toggle={this.handleClick_cancel}
            className="bg-info text-white"
            close={closeBtn}
          >
            <FontAwesomeIcon icon="edit" className="fa-fw mr-2" />
            Edit Project Units
          </ModalHeader>
          <ModalBody>
            <div className="d-flex flex-row">
              <div className="d-flex flex-column flex-fill pr-2 left-panel">
                <div className="card flex-grow-1">
                  <div className="card-body">
                    <div className="form-inline mb-2">
                      <label
                        htmlFor="distFilter"
                        className="col-form-label align-middle mr-2 text-muted"
                      >
                        <span className="h5">Selecting Units From:</span>
                      </label>
                      <Select
                        name="distFilter"
                        id="distFilter"
                        className="col-sm-3 align-middle px-0 mr-2"
                        value={distFilter}
                        options={distOptions.with59}
                        onChange={this.handleChange_distFilter}
                        placeholder="Dist"
                        isSearchable={false}
                      />
                    </div>
                    <div className="flex-grow-1 border table-unit-list">
                      <MultiselectTable
                        className="table table-sm table-hover"
                        data={data || []}
                        selectedItems={selectedUnits || []}
                        deletedItems={deletedUnits || []}
                        columns={this.columns}
                        idPropName={"unitId"}
                        onSelect={this.addProjectUnit}
                        onDeselect={this.removeProjectUnit}
                        onSort={this.handleSort}
                        sortColumn={sortColumn}
                        showSearch={true}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="d-flex flex-column flex-fill right-panel">
                {this.renderProjectUnits()}
              </div>
            </div>
          </ModalBody>
          <ModalFooter className="bg-lightgray">
            <div className="form-group form-row form-inline float-right mb-0">
              <button
                type="button"
                name="saveProjAssignments"
                id="saveProjAssignments"
                className="btn btn-primary mr-2"
                onClick={this.handleSubmit_editProjectUnits}
              >
                Save
              </button>
              <button
                type="button"
                name="cancelProjAssignments"
                id="cancelProjAssignments"
                className="btn btn-secondary"
                onClick={toggleEditProjectUnitsModal}
              >
                Cancel
              </button>
            </div>
          </ModalFooter>
        </Modal>
        {showAlert_cancel && (
          <AlertModal
            alertKey={"cancelEditProjUnitsKey"}
            alertTitle={"Cancel Edit Project Units"}
            alertTitleClass="bg-warning"
            alertTitleIcon="exclamation-triangle"
            alertText="Are you sure you want to cancel?"
            acceptCaption={"Yes"}
            acceptClass={"danger"}
            provideReject={true}
            rejectCaption={"No"}
            rejectClass={"secondary"}
            handleAlertAction={this.handleAlert_cancel}
            showAlertModal={showAlert_cancel}
            toggleAlertModal={this.toggleAlert_cancel}
          />
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  user: state.authentication.user,
  unitList: state.users.openUnitLists[ownProps.tabId] || [],
  projectUnits: state.projects.projectUnitLists[ownProps.project.projectId] || [],
});

export default connect(mapStateToProps)(EditProjectUnitsModal);
